import type { ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router';
import { buttonClass } from './core';

/** A link that looks like a button (never nest a <button> inside a link). */
export function ButtonLink({ variant = 'secondary', size = 'md', icon, block, className, children, ...rest }: LinkProps & { variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'ok'; size?: 'sm' | 'md' | 'lg' | 'xl'; icon?: ReactNode; block?: boolean }) {
  return (
    <Link className={buttonClass(variant, size, block, className)} {...rest}>
      {icon}
      {children}
    </Link>
  );
}
